import {
  AcceptedResponse,
  VerifyEmailResponse,
  type RegistrationRequest,
} from "@regigov/contracts";
import { z } from "zod";
import { api } from "./client";

const post = (body: unknown): RequestInit => ({
  method: "POST",
  body: JSON.stringify(body),
});

/** Self-registration, email verification (E3) and forgot password (E4), docs/email.md. No sign-in needed. */
export const registrationApi = {
  register: (input: RegistrationRequest) =>
    api("/auth/register", AcceptedResponse, post(input)),
  verify: (token: string) =>
    api("/auth/verify-email", VerifyEmailResponse, post({ token })),
  resend: (email: string) =>
    api("/auth/resend-verification", AcceptedResponse, post({ email })),
  forgot: (email: string) =>
    api("/auth/forgot-password", AcceptedResponse, post({ email })),
  reset: (token: string, newPassword: string) =>
    api("/auth/reset-password", z.null(), post({ token, newPassword })),
};
